import { z } from 'zod';

// Define the schema for form validation using Zod
export const contactFormSchema = z.object({
  name: z
    .string()
    .min(2, { message: 'Name must be at least 2 characters' })
    .max(100, { message: 'Name must be less than 100 characters' })
    .regex(/^[A-Za-z\s\-'.]+$/, { 
      message: 'Name should only contain letters, spaces, hyphens, and apostrophes' 
    }),
  
  email: z
    .string()
    .email({ message: 'Please enter a valid email address' })
    .max(100, { message: 'Email must be less than 100 characters' }),
  
  phone: z
    .string()
    .min(10, { message: 'Phone number must be at least 10 digits' })
    .regex(/^[0-9]{10}$/, { message: 'Phone number must be exactly 10 digits' }),
  
  quantity: z
    .string()
    .min(1, { message: 'Quantity is required' })
    .regex(/^[0-9]+$/, { message: 'Quantity must be a number' })
    .max(20, { message: 'Quantity must be less than 20 characters' }),
  
  state: z
    .string()
    .min(1, { message: 'Please select a state' }),
  
  product: z
    .enum([
      'pet-bottles',      
      'beverage-can', 
      'food-can',
      'pet-preforms',
      'sealing-machine',
      'be-our-distributor',
      'other'
    ], {
      errorMap: () => ({ message: 'Please select a product of interest from the list' })
    }),
  
  request_details: z
    .string()
    .min(10, { message: 'Request details must be at least 10 characters' })
    .max(1000, { message: 'Request details must be less than 1000 characters' }),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;
